import { nanoid } from 'nanoid'
import axios, { AxiosError } from 'axios'
import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { CDN_FRONT } from 'shared/config'

type ICallback = (value: boolean) => void

class CheckInternetAPI {
  private _isOnline = true
  private _callbacks: Map<ICallback, ICallback> = new Map()
  // private _worker = new Worker('/worker.js')

  constructor() {
    makeAutoObservable(this)

    this._init()
  }

  private _init = () => {
    // this._worker.onmessage = (e) => {
    //   if (e.data.action === 'detect_fast') {
    //     this._check()
    //   }
    // }
  }

  subscribe = (callback: (value: boolean) => void) => {
    this._callbacks.set(callback, callback)
  }

  unsubscribe = (callback: (value: boolean) => void) => {
    this._callbacks.delete(callback)
  }

  dispose = () => {
    this._callbacks.clear()
  }

  private _check = async () => {
    if (this._isOnline) return

    await this.check()
  }

  check = async () => {
    try {
      await axios.get(`https://${CDN_FRONT}/ui/v2/images/check-internet.png?id=${nanoid()}`)

      this.setIsOnline(true)
    } catch (e) {
      if (e instanceof AxiosError) {
        logger.error(e)

        if (e.code === 'ERR_NETWORK') this.setIsOnline(false)
      }
    }
  }

  setIsOnline = (value: boolean) => {
    if (this._isOnline === value) return

    this._isOnline = value

    this._callbacks.forEach((cb) => {
      cb(value)
    })
  }

  get isOnline() {
    return this._isOnline
  }
}

export const CheckInternet = new CheckInternetAPI()
